import React from 'react';
import { X } from 'lucide-react';
import { Section } from './Shared';
export const PainPoints = () => {
  const points = ['Llegando a la sesión sin un protocolo claro para el cuadro que tenés enfrente.', 'Dudando entre diagnósticos porque no tenés un algoritmo de 3 pasos que te guíe.', 'Sin versión de digitopuntura cuando el paciente no tolera las agujas.', 'Sin protocolo de urgencia cuando llega una crisis nerviosa o ataque de pánico en sesión.', 'Sin saber qué hierbas o alimentos recomendar para reforzar el tratamiento.', 'Sin ficha clínica profesional — cada consulta sin registro ni continuidad.', 'Pacientes que no vuelven porque no perciben resultados concretos.', 'Cada sesión empezás de cero, sin dirección real ni estructura clínica.'];
  return <Section className="max-w-4xl" data-id="element-333">
      <div className="text-center mb-12" data-id="element-334">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-display font-bold mb-6 leading-tight text-brand-greenDark" data-id="element-335">
          ¿Cuántas sesiones más vas a improvisar?
        </h2>
        <p className="text-brand-text/80 mb-4 text-sm md:text-base max-w-2xl mx-auto" data-id="element-336">
          Sos terapeuta de MTC. Amás lo que hacés. Pero nadie te dijo que ibas a
          llegar a la sesión dudando qué puntos trabajar, sin saber cómo
          responder ante una crisis nerviosa y sin un registro clínico que te
          respalde.
        </p>

        <p className="text-lg md:text-xl font-medium text-brand-green mt-6 font-serif italic" data-id="element-337">
          No es falta de vocación. Es falta de un sistema.
        </p>
      </div>

      <div className="glass-panel p-6 md:p-10 rounded-3xl mb-12 bg-white/70 border-brand-green/20" data-id="element-338">
        <h3 className="font-serif font-bold mb-6 flex items-center text-brand-greenDark text-base md:text-lg" data-id="element-339">
          <X className="w-6 h-6 text-brand-cupping mr-2 shrink-0" data-id="element-340" /> Lo que pasa
          sin el Kit MTC:
        </h3>
        <ul className="space-y-4" data-id="element-341">
          {points.map((point, i) => <li key={i} className="flex items-start" data-id="element-342">
              <X className="w-5 h-5 text-brand-cupping/80 mr-3 mt-0.5 shrink-0" data-id="element-343" />
              <span className="text-brand-text/80 text-sm md:text-base" data-id="element-344">
                {point}
              </span>
            </li>)}
        </ul>
      </div>

      <div className="text-center" data-id="element-345">
        <h3 className="text-xl md:text-3xl font-display font-bold purple-gradient-text" data-id="element-346">
          ¿Y si esta fuera la última sesión que trabajás así?
        </h3>
      </div>
    </Section>;
};